import { combineReducers } from "redux";
import integrationReducer from "./integrationReducer";
import credReducer from "./credReducer";
import jiraReducer from "./jiraReducer";
import messageReducer from "./messageReducer";
import authorizationReducer from "./authorizationReducer";
import notificationReducer from "./notificationReducer";
import testFowReducer from "./testFowReducer";
import wizardReducer from "./wizardReducer";
import jiraAssetReducer from "./jiraAssetReducer";
import backupReducer from "./backupReducer";
import versionReducer from "./versionReducer";
export default combineReducers({
  integration: integrationReducer,
  auth: credReducer,
  jira: jiraReducer,
  message: messageReducer,
  authorization: authorizationReducer,
  notification: notificationReducer,
  test: testFowReducer,
  wizard: wizardReducer,
  jiraAssets: jiraAssetReducer,
  backups: backupReducer,
  version: versionReducer,
});
